import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import "../css/terms.css";

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Resumify | Privacy Policy</title>
        <meta
          name="description"
          content="Read Resumify's privacy policy to understand how we collect, use, and protect your personal data and CV content."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <div className="home-page">
        <Navbar />
        <main className="legal-container">
          <div className="legal-card">
            <h1>Privacy Policy</h1>
            <p className="legal-date">Last updated: October 2026</p>

            <h2>1. Introduction</h2>
            <p>
              At Resumify ("we", "our", or "us"), accessible from
              resumify.co.uk, your privacy is a top priority. This Privacy
              Policy document outlines the types of information we collect, how
              we use it, and how we keep it secure.
            </p>

            <h2>2. Information We Collect</h2>
            <p>
              We collect information you provide directly to us when creating an
              account, building a CV, or communicating with support:
            </p>
            <ul>
              <li>
                <strong>Account Credentials:</strong> Email address and
                encrypted account passwords.
              </li>
              <li>
                <strong>CV Content:</strong> Professional details, work history,
                education, skills, custom links, and optional profile pictures.
              </li>
              <li>
                <strong>Transaction Data:</strong> Payment metadata processed
                securely through our payment provider, Stripe. We do not store
                full credit card numbers on our servers.
              </li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>
              Your information is used strictly to provide and enhance our
              services, including:
            </p>
            <ul>
              <li>
                Saving, loading, and auto-syncing your CVs across sessions.
              </li>
              <li>
                Powering our AI writing assistants to tailor professional bullet
                points and summaries.
              </li>
              <li>
                Processing secure PDF exports and managing subscription credit
                balances.
              </li>
              <li>
                Sending critical account notices, security updates, and customer
                support replies.
              </li>
            </ul>

            <h2>4. Data Sharing & Security</h2>
            <p>
              We do not sell, trade, or rent your personal data or CV details to
              third-party marketers. Your data is stored on secure cloud
              database architecture with strict access controls.
            </p>

            <h2>5. Your Rights</h2>
            <p>
              You maintain full ownership of your data. You may update your
              information, export your CVs to PDF, or delete your account and
              associated CV records at any time from your dashboard.
            </p>

            <h2>6. Contact Us</h2>
            <p>
              If you have any questions or concerns regarding our privacy
              practices, please reach out to our team at{" "}
              <a href="mailto:admin@resumify.co.uk">admin@resumify.co.uk</a>.
            </p>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
